import React from 'react';
import { ComponentTypes } from 'logi-embed/types';
import { LogiComponent } from '../LogiComponent';
/**
 * LogiDashboardBuilder component.
 * Embedds Dashboard Builder for Logi Composer. Can use with existing dashboard or create new one
 *
 * @component
 * @param {LogiDashboardBuilderProps} props - The component props.
 * @param {object} props.configuration - Optional The configuration for dashboard builder.
 * @param {() => Promise<object>} props.getToken - The function that returns the token needed for embedding.
 * @param {string} props.logiBaseUrl - The base URL for the Logi Composer.
 * @param {string} props.dashboardStyleWidth - Optional The width style for the dashboard.
 * @param {string} props.dashboardStyleHeight - Optional The height style for the dashboard.
 * @example
 * // Example usage of LogiDashboardBuilder component
 * <LogiDashboardBuilder
 *    configuration={configuration}
 *    getToken={getToken}
 *    logiBaseUrl="https://example.com"
 *    dashboardStyleWidth="100%"
 *    dashboardStyleHeight="70vh"
 * />
 */
export const LogiDashboardBuilder = ({ configuration, getToken, logiBaseUrl, dashboardStyleWidth, dashboardStyleHeight, }) => {
    return (React.createElement(LogiComponent, { componentType: ComponentTypes.DASHBOARD, configuration: configuration !== null && configuration !== void 0 ? configuration : {}, getToken: getToken, logiBaseUrl: logiBaseUrl, styleWidth: dashboardStyleWidth, styleHeight: dashboardStyleHeight }));
};
